document.querySelectorAll('.header__menu-item--has-children > a:first-of-type').forEach(el => {
	el.addEventListener('click', (e) => {
		var mediaQuery = window.matchMedia("(max-width: 999px)");
		if (mediaQuery.matches){
			e.preventDefault();
			if (el.closest('.header__menu-item--has-children').classList.contains('open-sub-nav')) {
				el.closest('.header__menu-item--has-children').classList.remove('open-sub-nav');
				return;
			}

			document.querySelectorAll('.header__menu-item--has-children').forEach(el => {
				el.classList.remove('open-sub-nav');
			});

			el.closest('.header__menu-item--has-children').classList.add('open-sub-nav');
		}
	})
});